<script>
import lazyLoadComponent from '@router/lazyload-component'

export default {
  page: {
  },
  components: {
  },
  filters: {

  },

  props: {
    merchantProducts: {
      type: Array,
      required: true,
    },
    serviceCategory: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeTab: this.$route.params.activeTab || '1',
      tabList: Object.freeze([
        {
          title: '時段價格',
          component: () => lazyLoadComponent(import('@src/router/views/prices/components/listComponent.vue')),
        },
        {
          title: '超時與額外收費',
          component: () => lazyLoadComponent(import('./TabOverTime')),
        },
        {
          title: '調價設定',
          component: () => lazyLoadComponent(import('./TabChangePrice')),
        }
      ]),
    }
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  methods: {
    toClick() { }
  },
}
</script>

<template>
  <div>
    <el-tabs ref="tab" v-model="activeTab" stretch class="is-no-border is-no-bg isStyleBaseLine isSecond"
      :class="$style.innerTabStyle" @tab-click="toClick">
      <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index + 1}`">
      </el-tab-pane>
    </el-tabs>
    <div v-for="(tab, index) in tabList" :class="$style.layer2Component">
      <component :is="tab.component" v-if="Number(activeTab) === index + 1" :merchant-products="merchantProducts"
        :service-category="serviceCategory" type="daycare" :tableCheckboxShow="true">
      </component>
    </div>
  </div>
</template>

<style lang="scss" module>
.innerTabStyle {
  :global {
    .el-tabs__header {
      margin-bottom: 5px;
      padding-bottom: 1px;
      background-color: $color-body-bg;
      box-shadow: 0 2px 5px #EFF0F1;
      margin-left: -15px;
      margin-right: -15px;

      .el-tabs__item {
        padding-left: 0;
        padding-right: 0;
        color: #909399;

        &:last-child {
          border-right: 1px solid #E5E7EB;
        }

        &.is-active {}
      }
    }

    .el-tabs__content {
      padding-top: 15px;
      background-color: #F9FAFB;
    }
  }
}

.layer2Component {
  margin: 15px;
}
</style>
